import type Phaser from "phaser";
import type { BorgCubeSprite } from "../BorgCube";
import { PhaserBeamSystem } from "./PhaserBeam";
import { TorpedoSystem } from "./Torpedo";

/**
 * Unified weapon system coordinating all player weapons.
 */
export class WeaponSystem {
  readonly torpedoes: TorpedoSystem;
  readonly phasers: PhaserBeamSystem;

  constructor(
    scene: Phaser.Scene,
    ship: Phaser.Physics.Arcade.Sprite,
    borgGroup: Phaser.Physics.Arcade.Group,
  ) {
    this.torpedoes = new TorpedoSystem(scene, ship);
    this.phasers = new PhaserBeamSystem(scene, ship, borgGroup);
  }

  create(): void {
    this.torpedoes.create();
    this.phasers.create();
  }

  /**
   * Update all weapon systems
   */
  update(
    delta: number,
    screenWrap: (sprite: Phaser.Physics.Arcade.Sprite) => void,
  ): void {
    this.torpedoes.update(delta, screenWrap);
    this.phasers.update(delta);
  }

  /**
   * Called when player dies/hides - stops all active weapons
   */
  hide(): void {
    this.phasers.hide();
  }

  /**
   * Notify weapon systems that a target was destroyed
   */
  notifyTargetDestroyed(target: BorgCubeSprite): void {
    this.phasers.notifyTargetDestroyed(target);
  }

  /**
   * Cleanup all resources
   */
  destroy(): void {
    this.torpedoes.destroy();
    this.phasers.destroy();
  }
}

// Re-export for convenience
export { TorpedoSystem, type TorpedoSprite } from "./Torpedo";
export { PhaserBeamSystem } from "./PhaserBeam";
